import { startListening, trackEvent } from '@bonanza-social/toolkit/state';
import { claimDailyGift } from './dailyGift.slice';

startListening({
  actionCreator: claimDailyGift.fulfilled,
  effect: (action, { dispatch }) => {
    dispatch(
      trackEvent({
        name: 'daily_gift_claimed',
        params: {
          rewardAmount: action.payload.rewardAmount.toString(),
          rewardType: action.payload.rewardType,
        },
      }),
    );
  },
});
